import { createSlice } from '@reduxjs/toolkit'
import { planStatuses, singleProductPlanStatuses } from '../utils/plans'

const initialState = {
  planList: {},
  selectedPlan: {},
}

const planSlice = createSlice({
  name: 'planSlice',
  initialState,
  reducers: {
    setPlanList: (state, action) => {
      const plans = action.payload.map((plan, index) => {
        const status = ['isActive', 'isUnderCancellation', 'isOnHold', 'isCancelled', 'isExpired'].find((planStatus) => {
          const currentStatus = plan.groupSoldPlanStatus
            ? planStatuses[plan.status][plan.groupSoldPlanStatus][planStatus]
            : singleProductPlanStatuses[plan.status] && singleProductPlanStatuses[plan.status][planStatus]
          return currentStatus
        })
        plan[status] = true
        return plan
      })
      state.planList = plans
    },
    setSelectedPlan: (state, action) => {
      state.selectedPlan = action.payload
    },
  },
})

export default planSlice.reducer

export const { setPlanList, setSelectedPlan } = planSlice.actions
